import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from '../ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Plus } from 'lucide-react';
import { MEAL_SERVICES } from './AddIntegrationDialog';

const ScheduleMealDialog = ({ open, onOpenChange, order, setOrder, enabledIntegrations, getServiceIcon, onSubmit }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogTrigger asChild>
      <Button size="sm" className="btn-secondary" data-testid="schedule-meal-btn">
        <Plus className="w-4 h-4 mr-2" />
        Schedule Meal
      </Button>
    </DialogTrigger>
    <DialogContent className="surface-card">
      <DialogHeader>
        <DialogTitle>Schedule Meal Delivery</DialogTitle>
        <DialogDescription>Coordinate a meal for your circle member</DialogDescription>
      </DialogHeader>
      <form onSubmit={onSubmit} className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="meal-service">Service</Label>
          <Select value={order.integration_id} onValueChange={(value) => setOrder({ ...order, integration_id: value })}>
            <SelectTrigger data-testid="meal-service-select"><SelectValue placeholder="Select service" /></SelectTrigger>
            <SelectContent>
              {enabledIntegrations.map((integration) => (
                <SelectItem key={integration.id} value={integration.id}>
                  {getServiceIcon(integration.service_name)} {MEAL_SERVICES.find(s => s.value === integration.service_name)?.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <div className="space-y-2">
          <Label htmlFor="delivery-address">Delivery Address</Label>
          <Textarea id="delivery-address" data-testid="delivery-address-input" placeholder="Enter full delivery address"
            value={order.delivery_address} onChange={(e) => setOrder({ ...order, delivery_address: e.target.value })} required className="resize-none" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="delivery-time">Preferred Delivery Time</Label>
          <Input id="delivery-time" type="datetime-local" data-testid="delivery-time-input"
            value={order.delivery_time} onChange={(e) => setOrder({ ...order, delivery_time: e.target.value })} />
        </div>
        <div className="space-y-2">
          <Label htmlFor="meal-notes">Notes</Label>
          <Textarea id="meal-notes" data-testid="meal-notes-input" placeholder="Special instructions, dietary needs, etc."
            value={order.notes} onChange={(e) => setOrder({ ...order, notes: e.target.value })} className="resize-none" />
        </div>
        <Button type="submit" className="w-full btn-primary" data-testid="submit-meal-order-btn">Schedule Meal</Button>
      </form>
    </DialogContent>
  </Dialog>
);

export default ScheduleMealDialog;
